const UserLogin = "Login";

export default UserLogin;